module.exports = __webpack_public_path__ + "img/patrolman_banner@2x.5d141aa9.png";